import { createContext, ReactNode, use } from "react";
import {
  ThreadPresence,
  useThreadPresenceChannel,
} from "@/app/Threads/hooks/useThreadPresenceChannel";

const ThreadPresenceContext = createContext<ThreadPresence | null>(null);

export function ThreadPresenceProvider({
  threadId,
  children,
}: {
  threadId: string;
  children: ReactNode;
}) {
  const presence = useThreadPresenceChannel(threadId);

  return (
    <ThreadPresenceContext value={presence}>{children}</ThreadPresenceContext>
  );
}

export function useThreadPresence(): ThreadPresence | null {
  return use(ThreadPresenceContext);
}
